import { commonUtils } from '@/helpers/commonUtils'
import styles from './PdfPageEnd.module.less'
import PdfPage, { PageHeader } from '../PdfPage/PdfPage'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import AiTip from '@/components/AiTip/AiTip'
import { INTERNAL_HOST } from '@/commonConst'
interface Props {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  no: number
}

function PdfPageEnd({ project, onRendered, no }: Props) {
  const { t, i18n } = useTranslation()
  const isJaLocale = (i18n.resolvedLanguage || i18n.language || '').toLowerCase().startsWith('ja')
  useEffect(() => {
    onRendered(1)
  }, [])
  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-1/PDF-bg-1.jpg')} no={no}>
      <div className={styles.pdfPageEnd}>
        <PageHeader project={project} />
        <div className={styles.briefLine}></div>
        {!isJaLocale && <p className={styles.title}>{t('dashboard.pdf.theEnd')}</p>}
        <p className={styles.title}>{t('dashboard.pdf.thankYouForWatching')}</p>

        <img
          className={styles.next}
          src={commonUtils.getImagePath('PDFDownload/back.png')}
          alt=''
        />
      </div>
      {
        INTERNAL_HOST.includes(location.hostname) &&
        <AiTip style={{ marginTop: 400, marginLeft: 100, fontSize: 20 }} />
      }
    </PdfPage>
  )
}

export default PdfPageEnd
